import { Button, ButtonGroup } from "@mui/material"

export function MaintenancePage() {
  return (
    <div>
      <div
        style={{
          width: "100%",
          height: "50vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "rgba(254.31, 240.56, 216.41)",
          borderRadius: "1rem",
        }}
      >
        <img
          src="/botega-maintenance.png"
          alt="Maintenance"
          style={{ maxWidth: "60%", maxHeight: "60%" }}
        />

        <div
          style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: "2rem",
          }}
        >
          <Button
            variant="contained"
            href="https://discord.com/invite/AK6C2PPWDc"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              backgroundColor: "rgba(87.954, 52.422, 28.721)",
              color: "#fff",
              "&:hover": {
                backgroundColor: "rgba(218.64, 134.19, 64.067)",
              },
              padding: "0.75rem 2rem",
              fontSize: "2rem",
              fontWeight: 600,
              borderRadius: "1.75rem",
            }}
          >
            Join our Discord
          </Button>
        </div>
      </div>
    </div>
  )
}
